<template>
  <a-modal
    :visible="isVisible"
    :dialog-style="{ top: '5%' }"
    @ok="closeModal"
    @cancel="closeModal"
    :footer="null"
    width="40%"
    class="upgrade-modal-container"
  >
    <div class="upgrade-modal">
      <!-- Header with Logo and Title -->
      <div class="modal-header">
        <div class="logo-container">
          <img
            src="/resources/images/logos/favicon 512.png"
            alt="EdTrust Logo"
            class="company-logo"
          />
        </div>
        <div class="header-content">
          <h2 class="modal-title">{{ $t("pack.upgradeModal.title") }}</h2>
          <p class="modal-subtitle">{{ $t("pack.upgradeModal.subtitle") }}</p>
        </div>
      </div>

      <!-- Main Content -->
      <div class="modal-content">
        <div class="feature-lock">
          <a-icon type="lock" class="lock-icon" />
        </div>

        <p class="description">{{ $t("pack.upgradeModal.description") }}</p>

        <!-- Compact Contact Grid -->
        <div class="contact-grid">
          <div class="contact-item" @click="contactSales">
            <div class="contact-icon-wrapper phone">
              <a-icon type="phone" />
            </div>
            <div class="contact-info">
              <span class="contact-label">{{
                $t("pack.upgradeModal.phone")
              }}</span>
              <span class="contact-value">+216 52 588 822</span>
            </div>
          </div>

          <div class="contact-item">
            <div class="contact-icon-wrapper email">
              <a-icon type="mail" />
            </div>
            <div class="contact-info">
              <span class="contact-label">{{
                $t("pack.upgradeModal.email")
              }}</span>
              <span class="contact-value">commercial@edtrust.tn </span>
            </div>
          </div>

          <div class="contact-item">
            <div class="contact-icon-wrapper website">
              <a-icon type="global" />
            </div>
            <div class="contact-info">
              <span class="contact-label">{{
                $t("pack.upgradeModal.website")
              }}</span>
              <a
                :href="'https://edtrust.tn/fr/contact-us'"
                target="_blank"
                class="contact-value website-link"
              >
                www.edtrust.tn
              </a>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <a-button
            type="primary"
            size="large"
            class="contact-sales-btn"
            @click="contactSales"
          >
            <a-icon type="export" />
            {{ $t("pack.upgradeModal.contactSales") }}
          </a-button>

          <a-button size="large" class="close-btn" @click="closeModal">
            {{ $t("pack.upgradeModal.close") }}
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    isVisible: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    contactSales() {
      window.open("https://edtrust.tn/fr/contact-us");
    },
  },
};
</script>

<style lang="scss" scoped>
.upgrade-modal-container {
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
  }
}

.upgrade-modal {
  padding: 0;

  .modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px 24px 16px;
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 70%
      );
      animation: float 6s ease-in-out infinite;
    }

    .logo-container {
      margin-bottom: 12px;

      .company-logo {
        width: 80px;
        height: 80px;
        object-fit: contain;
        filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.3));
        background: rgba(255, 255, 255, 0.452);
        border-radius: 16px;
        padding: 8px;
        backdrop-filter: blur(10px);
        border: 2px solid rgba(255, 255, 255, 0.2);
      }
    }

    .header-content {
      position: relative;
      z-index: 1;

      .modal-title {
        color: white;
        font-size: 20px;
        font-weight: 700;
        margin: 0 0 8px 0;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }

      .modal-subtitle {
        color: rgba(255, 255, 255, 0.9);
        font-size: 14px;
        margin: 0;
        line-height: 1.4;
      }
    }
  }

  .modal-content {
    padding: 20px;

    .feature-lock {
      text-align: center;
      margin-bottom: 16px;

      .lock-icon {
        font-size: 48px;
        color: #ff6b6b;
        background: linear-gradient(135deg, #ff6b6b, #ee5a24);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        filter: drop-shadow(0 2px 4px rgba(255, 107, 107, 0.3));
      }
    }

    .description {
      text-align: center;
      color: #666;
      font-size: 14px;
      line-height: 1.5;
      margin-bottom: 20px;
      padding: 0 16px;
    }

    .contact-grid {
      display: grid;
      gap: 12px;
      margin-bottom: 20px;

      .contact-item {
        display: flex;
        align-items: center;
        padding: 10px 16px;
        background: #f8f9fa;
        border-radius: 12px;
        border: 2px solid transparent;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          border-color: #e3f2fd;
        }

        .contact-icon-wrapper {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          font-size: 16px;
          color: white;
          transition: all 0.3s ease;

          &.phone {
            background: linear-gradient(135deg, #4caf50, #2e7d32);
          }

          &.email {
            background: linear-gradient(135deg, #2196f3, #1976d2);
          }

          &.website {
            background: linear-gradient(135deg, #ff9800, #f57c00);
          }
        }

        .contact-info {
          flex: 1;

          .contact-label {
            display: block;
            font-size: 11px;
            color: #999;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 2px;
          }

          .contact-value {
            display: block;
            font-size: 13px;
            color: #333;
            font-weight: 600;

            &.website-link {
              color: #2196f3;
              text-decoration: none;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }

    .action-buttons {
      display: flex;
      gap: 10px;
      justify-content: center;

      .contact-sales-btn {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        height: 40px;
        padding: 0 24px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        transition: all 0.3s ease;
        flex: 1;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .anticon {
          margin-right: 6px;
        }
      }

      .close-btn {
        height: 40px;
        padding: 0 24px;
        font-size: 14px;
        border-radius: 12px;
        border: 2px solid #e0e0e0;
        color: #666;
        background: white;
        transition: all 0.3s ease;
        min-width: 100px;

        &:hover {
          border-color: #667eea;
          color: #667eea;
          background: #f8f9ff;
        }
      }
    }
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

// Responsive adjustments
@media (max-width: 576px) {
  .upgrade-modal {
    .modal-header {
      padding: 20px 20px 16px;

      .logo-container .company-logo {
        width: 50px;
        height: 50px;
      }

      .header-content {
        .modal-title {
          font-size: 18px;
        }

        .modal-subtitle {
          font-size: 13px;
        }
      }
    }

    .modal-content {
      padding: 20px;

      .contact-grid .contact-item {
        padding: 10px 14px;

        .contact-icon-wrapper {
          width: 36px;
          height: 36px;
          font-size: 16px;
          margin-right: 12px;
        }

        .contact-info {
          .contact-value {
            font-size: 13px;
          }
        }
      }

      .action-buttons {
        flex-direction: column;
        gap: 10px;

        .contact-sales-btn,
        .close-btn {
          width: 100%;
          height: 38px;
        }
      }
    }
  }
}
</style>
